import styled from "styled-components";

const ContentDiv = styled.div`
  margin-top: 20px;
`;

export default ContentDiv;



// WEBPACK FOOTER //
// ./app/javascript/components/core/TabContentDiv.tsx